
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.5 18.958h-15a.63.63 0 01-.625-.625.63.63 0 01.625-.625h15a.63.63 0 01.625.625.63.63 0 01-.625.625zM4.667 16.458H3.333c-.8 0-1.458-.658-1.458-1.458V7.817c0-.8.658-1.459 1.458-1.459h1.334c.8 0 1.458.659 1.458 1.459V15c0 .8-.658 1.458-1.458 1.458zM3.333 7.6a.206.206 0 00-.208.208V15c0 .117.092.208.208.208h1.334A.206.206 0 004.875 15V7.817a.206.206 0 00-.208-.209H3.333V7.6zM10.667 16.458H9.333c-.8 0-1.458-.658-1.458-1.458V5.158c0-.8.658-1.458 1.458-1.458h1.334c.8 0 1.458.658 1.458 1.458V15c0 .8-.658 1.458-1.458 1.458zM9.333 4.95a.206.206 0 00-.208.208V15c0 .117.092.208.208.208h1.334a.206.206 0 00.208-.208V5.158a.206.206 0 00-.208-.208H9.333zM16.667 16.458h-1.334c-.8 0-1.458-.658-1.458-1.458V2.5c0-.8.658-1.458 1.458-1.458h1.334c.8 0 1.458.658 1.458 1.458V15c0 .8-.658 1.458-1.458 1.458zM15.333 2.292a.206.206 0 00-.208.208V15c0 .117.092.208.208.208h1.334a.206.206 0 00.208-.208V2.5a.206.206 0 00-.208-.208h-1.334z","fill":"#fff"}})])
          )
        }
      }
    